import React from 'react';
import { motion } from 'framer-motion';
import { FiMenu, FiUser, FiLogOut, FiBookOpen } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { useSettings } from '../../context/SettingsContext';
import { Link } from 'react-router-dom';
import BrandLogo from '../../components/common/BrandLogo';

const Navbar = ({ onMenuClick }) => {
  const { currentUser, logout } = useAuth();
  const { settings } = useSettings();
  const [profileOpen, setProfileOpen] = React.useState(false);

  // 品牌标题与Logo（读取系统设置，未设置时使用默认）
  const systemTitle = settings?.systemTitle || '运维总控';
  const systemLogo = settings?.systemLogo || '';

  // 处理注销
  const handleLogout = () => {
    logout();
  };

  return (
    <header className="bg-white/90 border-b border-[#d0d7de] sticky top-0 z-30">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* 左侧菜单按钮和标题 */}
          <div className="flex items-center min-w-0">
            <button
              type="button"
              className="text-[#57606a] hover:text-[#1f2328] focus:outline-none md:hidden"
              onClick={onMenuClick}
              aria-label="打开菜单"
            >
              <FiMenu className="h-6 w-6" />
            </button>
            <div className="ml-3 md:ml-0 flex items-center min-w-0">
              {systemLogo ? (
                <img
                  src={systemLogo}
                  alt="logo"
                  className="h-8 w-8 rounded object-contain mr-3 shrink-0"
                />
              ) : (
                <span className="mr-3 shrink-0"><BrandLogo size={32} /></span>
              )}
              <motion.div
                className="gradient-text text-xl font-semibold truncate"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                {systemTitle}
              </motion.div>
            </div>
          </div>

          {/* 右侧用户菜单 */}
          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            {/* 文档入口 */}
            <Link
              to="/api-docs"
              className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm text-[#57606a] hover:text-[#1f2328] hover:bg-[#f6f8fa] transition-colors"
            >
              <FiBookOpen className="h-4 w-4" />
              <span>接口文档</span>
            </Link>

            {/* 用户资料下拉菜单 */}
            <div className="relative">
              <motion.button
                className="flex items-center gap-2 px-3 py-1.5 text-sm text-[#1f2328] border border-[#d0d7de] rounded-md hover:bg-[#f6f8fa] bg-white"
                onClick={() => setProfileOpen(!profileOpen)}
                whileTap={{ scale: 0.98 }}
                aria-label="用户菜单"
              >
                <div className="h-6 w-6 rounded-full brand-bg flex items-center justify-center">
                  <FiUser className="h-3.5 w-3.5 text-white" />
                </div>
                <span className="hidden sm:inline max-w-[8rem] truncate">{currentUser?.username}</span>
              </motion.button>

              {/* 下拉菜单 */}
              {profileOpen && (
                <motion.div
                  className="absolute right-0 z-40 mt-2 w-48 origin-top-right rounded-md bg-white border border-[#d0d7de] shadow-md overflow-hidden"
                  initial={{ opacity: 0, scale: 0.95, y: -8 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.95, y: -8 }}
                  transition={{ duration: 0.15 }}
                >
                  <div className="px-4 py-3 border-b border-[#d0d7de]">
                    <p className="text-sm text-[#1f2328] truncate">{currentUser?.username}</p>
                    <p className="text-xs text-[#57606a] mt-0.5">
                      {currentUser?.role === 'admin' ? '管理员' : '普通用户'}
                    </p>
                  </div>
                  <div className="py-1">
                    <Link
                      to="/profile"
                      className="flex items-center px-4 py-2 text-sm text-[#1f2328] hover:bg-[#f6f8fa]"
                      onClick={() => setProfileOpen(false)}
                    >
                      <FiUser className="mr-2 text-[#57606a]" />
                      个人资料
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full text-left px-4 py-2 text-sm text-[#cf222e] hover:bg-[#ffebe9]"
                    >
                      <FiLogOut className="mr-2" />
                      退出登录
                    </button>
                  </div>
                </motion.div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
